export default "__VITE_ASSET__hOabee0B__"